import React from "react";


const FieldLabel = (props) => {
  const {id, label, tooltip} = props;
  return (
    <label className="form-input__label" htmlFor={id}>
      {label && <span className="form-input__label-content">{label}</span>}
      {tooltip && <span style={{pointerEvents: "auto"}}>{tooltip}</span>}
    </label>
  );
};


export default FieldLabel;
